<div>
  <div>
    <vehicle-edit-form (response)="addItem($event)" />
  </div>

  <div class="mt-4">
    <!-- <form-client-search
          [search]="inputSearchClient"
          [listSearch]="listSearch"
          
        /> -->

    <!-- @if (checkPermission('pesquisar-paginado')) {
         <form-search [search]="inputSearch" (responseSearch)="search($event)" />
    } -->
    @if(itemsList && itemsList.length >= 0){
      
      <div class="p-4">
        @if (!loading) {
        <div class="tab-overflow">
          <table mat-table [dataSource]="tableSource" class="mat-elevation-z8">
            @for(column of columns; track column.keyColumn) {
            <ng-container matColumnDef="{{ column.keyColumn }}">
              <th mat-header-cell *matHeaderCellDef>{{ column.description }}</th>
              <td mat-cell *matCellDef="let element">
                @if(column.keyColumn == 'action') {
                <div class="flex justify-center items-center gap-3">
                  @if(column.key.delete) {
                  <mat-icon class="btn-icon-outline" fontIcon="delete" (click)="deleteItem(element)" />
                  }
                </div>
                }@else {
                {{ element[column.key] }}
                }
              </td>
            </ng-container>
            }
            <tr mat-header-row class="style-header" *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row class="style-row" *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
        } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
        }
      </div>
    }@else{
      <div class="flex justify-center items-center">
        <div class="mt-4">
          <h4>Nenhum Documento cadastrado</h4>
        </div>
      </div>
    }
  </div>
</div>